<template>
  <div class="login abs left0 right0 bottom0 top0" :style="bg">
    <div class="login-warp">
      <img class="login-logo" src="@/assets/imgs/b2.png" alt="">

      <div class="login-box">
        <p class="login-title">后台管理</p>

        <el-form ref="form" label-position="top" :model="form">
          <el-form-item prop="name" :rules="rules">
            <el-input
                placeholder="请输入登录账号"
                class="big-input"
                autofocus
                v-model.trim="form.name"
                @keydown.enter.native="submitForm"
            >
              <div slot="prefix">
                <img class="pl20 pr20" src="@/assets/imgs/icon1.png" alt>
              </div>
            </el-input>
          </el-form-item>
          <el-form-item :rules="rules" prop="password">
            <el-input
                placeholder="请输入登录密码"
                class="big-input"
                @keydown.enter.native="submitForm"
                type="password"
                v-model="form.password">
              <div slot="prefix">
                <img class="pl20 pr20" src="@/assets/imgs/icon2.png" alt>
              </div>
            </el-input>
          </el-form-item>
		  <!-- 短信验证码 begin -->
		  <!--  <el-form-item :rules="rules" prop="verCode">
		    <el-input
		        placeholder="请输入短信验证码"
		        class="big-input"
		        @keydown.enter.native="submitForm"
		        v-model="form.verCode">
		      <div slot="prefix">
		        <img class="pl20 pr20" src="@/assets/imgs/icon3.png" alt>
		      </div>
		    </el-input>
		  </el-form-item> -->
		  <!-- 短信验证码 end -->
          <el-form-item class="text-center">
            <el-button class="login-submit" :loading="loading" @click="submitForm">登录</el-button>
         
		<!-- 扫码登录 -->	
		<!--  </br></br>
			  <el-button>扫码登录</el-button> -->
		
		  </el-form-item>
		  
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
  import {login,getToken} from '@/api/index'
  export default {
    data () {
      return {
        // 模拟测试数据
        form: {
          name: '',
          password: ''
        },
        rules: this.$store.state.rules.required,
        // 登录按钮
        loading: false,
        bg: {
          backgroundImage: `url(${require('@/assets/imgs/b3.png')})`
        }
      }
    },
    created () {
      if (localStorage.token) {
         this.getUserDataFn()
      }
    },
    methods: {
      submitForm () {
        this.$refs.form.validate(valid => {
           if (!valid) return 0
           if (this.loading) return 0
           this.loading = true
           this.loginFn()
         })
      },
      loginFn () {
        this.loading = false
        login({
          account: this.form.name,
          pwd: this.form.password
        }).then(res => {

          if (res.code === 200) {
            let token = res.data;
            localStorage.token = token;
            //localStorage.userType = res.data.userTypeEnum.name
            //昵称信息通过token 获取
            //this.$store.commit('changeNickName', res.data.nickName)
            this.$router.push('/main')
          } else {
            this.$message.warning(res.msg)
          }
        }).finally(() => {
          this.loading = false
        })
      },
      getUserDataFn () {
        let token = localStorage.token;
        getToken({token:token}).then(res => {
          if (res.code == 200) {
            //localStorage.userType = res.data.userTypeEnum.name
            this.$store.commit('changeNickName', res.data.nickName)
            this.$message.success(`欢迎您,登录成功`)
            this.$router.push('/main')
          }
        })
      }
    }
  }
</script>

<style scoped>
  .login {
    background-color: #409eff;
    min-width: 1200px;
    background-repeat: no-repeat;
    background-size: cover;
  }

  .login-warp {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 800px;
    height: 486px;
    transform: translate(-50%, -50%);
    background-color: #fff;
    border-radius: 20px;
    box-shadow: 0 0 30px 2px #1c4baa;
  }

  .login-logo {
    width: 348px;
    height: 282px;
    position: absolute;
    left: 70px;
    top: 102px;
  }

  .login-box {
    position: absolute;
    right: 50px;
    width: 300px;
  }

  .login-title {
    color: #000;
    font-size: 30px;
    font-weight: bold;
    text-align: center;
    margin-bottom: 38px;
    margin-top: 59px;
  }

  .login-submit {
    margin-top: 30px;
    background-color: #00a0ea;
    width: 213px;
    border-radius: 22px;
    color: #ffffff;
    height: 44px;
  }
</style>
